import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import FormResolver from './components/FormResolver';
import Header from './components/Header';
import Login from './pages/Login';
import MicrosoftCallback from './pages/MicrosoftCallback';
import Dashboard from './pages/Dashboard';
import FormBuilder from './pages/FormBuilder';
import QuestionnaireBuilder from './pages/QuestionnaireBuilder';
import FormView from './pages/FormView';
import FormLanding from './pages/FormLanding';
import FormPreview from './pages/FormPreview';
import Responses from './pages/Responses';
import Analytics from './pages/Analytics';
import UserManagement from './pages/UserManagement';
import SharedFolder from './pages/SharedFolder';
import QRCodeGenerator from './pages/QRCodeGenerator';
import QRCodeManager from './pages/QRCodeManager';
import QRCodeRedirect from './pages/QRCodeRedirect';

const AppContainer = styled.div`
  min-height: 100vh;
  background: white;
`;

const MainContent = styled.main`
  padding-top: 80px; /* Account for fixed header */
  min-height: calc(100vh - 80px);
  position: relative;
`;

function App() {
  return (
    <AuthProvider>
      <AppContainer>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/microsoft/callback" element={<MicrosoftCallback />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Header />
              <MainContent>
                <Dashboard />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/builder" element={
            <ProtectedRoute>
              <Header />
              <MainContent>
                <FormBuilder />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/builder/:id" element={
            <ProtectedRoute>
              <Header />
              <MainContent>
                <FormBuilder />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/questionnaire-builder" element={
            <ProtectedRoute>
              <Header />
              <MainContent>
                <QuestionnaireBuilder />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/questionnaire-builder/:id" element={
            <ProtectedRoute>
              <Header />
              <MainContent>
                <QuestionnaireBuilder />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/form/:id/landing" element={
            <FormResolver>
              <FormLanding />
            </FormResolver>
          } />
          <Route path="/form/:id" element={
            <FormResolver>
              <FormView />
            </FormResolver>
          } />
          <Route path="/form/shared/:id" element={
            <FormResolver>
              <FormView />
            </FormResolver>
          } />
          <Route path="/preview/:id" element={<FormPreview />} />
          <Route path="/preview/preview" element={<FormPreview />} />
          <Route path="/responses/:formId" element={
            <ProtectedRoute>
              <Header />
              <MainContent>
                <Responses />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/analytics/:formId" element={
            <ProtectedRoute requireAdmin>
              <Header />
              <MainContent>
                <Analytics />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute requireAdmin>
              <Header />
              <MainContent>
                <Analytics />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute>
              <Header />
              <MainContent>
                <UserManagement />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/folder/:id" element={<SharedFolder />} />
          <Route path="/qr-generator" element={
            <ProtectedRoute requireAdmin>
              <Header />
              <MainContent>
                <QRCodeGenerator />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/qr-manager" element={
            <ProtectedRoute requireAdmin>
              <Header />
              <MainContent>
                <QRCodeManager />
              </MainContent>
            </ProtectedRoute>
          } />
          <Route path="/qr/:id" element={<QRCodeRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppContainer>
    </AuthProvider>
  );
}

export default App;
